// extracted by mini-css-extract-plugin
module.exports = {"Container":"styles_Container__2CW_S","ContainerFluid":"styles_ContainerFluid__3WdfM"};